import AiconeLogo from '@/components/config_components/AiconeLogo/AiconeLogo.vue'

const humanize_name = (value) => String(value || '')
  .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
  .replace(/[_-]+/g, ' ')
  .replace(/\s+/g, ' ')
  .trim();

export default {
  name: 'ConfigNavbar',
  components: {AiconeLogo},
  emits: [
    'toggle-sidebar',
    'toggle-ai-sidebar',
    'open-new-workflow-modal',
    'open-search-palette'
  ],
  props: {
    show_ai_sidebar: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    nav_meta() {
      return this.$route.meta || {};
    },
    nav_title() {
      return this.nav_meta.navTitle
        || this.nav_meta.pageTitle
        || this.nav_meta.title
        || humanize_name(this.$route.name || 'Dashboard');
    },
    nav_section() {
      if (this.nav_meta.navSection) {
        return this.nav_meta.navSection;
      }

      const section_from_title = humanize_name(this.$route.name || 'Compliance').split(' ')[0];
      return section_from_title || 'Compliance';
    },
    search_placeholder() {
      return this.nav_meta.searchPlaceholder || 'Search suppliers, contracts, controls, evidence...';
    },
    live_status_label() {
      return this.nav_meta.liveStatusLabel || 'Posture live · 1m ago';
    },
    user_name() {
      return this.$store.getters.currentLeadName || '';
    },
    role() {
      return this.$store.getters.currentRole || '';
    },
    user_initials() {
      return this.user_name
        .split(' ')
        .filter(Boolean)
        .map((part) => part[0])
        .join('')
        .slice(0, 2)
        .toUpperCase();
    }
  },
  methods: {
    sign_out() {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('otp_verified');
      sessionStorage.removeItem('is_aic_one_login');
      sessionStorage.removeItem('auth_redirect_reason');
      this.$store.dispatch('resetStore');
      this.$router.push({ name: 'UserLogin' });
    }
  }
}
